import 'css-chunksrc/client/scenes/notifications/notification/delayedTask/styles.scss';export default {
  "notification": "_notification_qvbs9_1",
  "header": "_header_qvbs9_8",
  "date": "_date_qvbs9_18",
  "main": "_main_qvbs9_24",
  "text": "_text_qvbs9_28",
  "task": "_task_qvbs9_35",
  "delayed": "_delayed_qvbs9_44"
};